import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { BaseService } from '../../core';
import { UsuarioResponse } from './response/login.response';
import { UsuarioRequest } from './request/usuario-register.request';
import { UserFilterRequest } from './request/user-filter.request';
import { UsuarioFuncionarioImobiliariaRequest } from 'app/shared/models/ei-models';
import { AtualizarPerfilRequest } from './request/atualizar-perfil.request';
import { AtualizarPerfilResponse } from './response/atualizar-perfil.response';
import { AceitarTermosResponse } from './response/aceitar-termos.response';
import { ConcluirOnboardingResponse } from './response/concluir-onboarding.response';
import { UsuarioListResponse } from './response/usuario-list.response';

@Injectable({ providedIn: 'root' })
export class UsuarioService extends BaseService {
  private usuarioEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Usuario/`;
  private loaderAtivo = true;

  constructor(private http: HttpClient) {
    super();
  }

  getUsuarioById(usuarioId: number): Observable<UsuarioResponse> {
    return this.http
      .get<any>(`${this.usuarioEndpoint}GetUsuarioById/${usuarioId}`, { headers: this.getHeader(this.loaderAtivo) })
      .pipe(map(raw => new UsuarioResponse(raw)));
  }

  cadastrar(request: UsuarioRequest): Observable<UsuarioResponse> {
    return this.http
      .post<any>(`${this.usuarioEndpoint}Cadastrar`, request, { headers: this.getHeader(this.loaderAtivo) })
      .pipe(map(raw => new UsuarioResponse(raw)));
  }

  cadastrarFuncionarioImobiliaria(request: UsuarioFuncionarioImobiliariaRequest): Observable<UsuarioResponse> {
    return this.http
      .post<any>(`${this.usuarioEndpoint}CadastrarFuncionarioImobiliaria`, request, { headers: this.getHeader(this.loaderAtivo) })
      .pipe(map(raw => new UsuarioResponse(raw)));
  }

  getUsuarios(filters?: UserFilterRequest): Observable<UsuarioListResponse[]> {
    let params = new HttpParams();
    
    if (filters) {
      if (filters.nome) params = params.set('nome', filters.nome);
      if (filters.cpf) params = params.set('cpf', filters.cpf);
      if (filters.perfilId) params = params.set('perfilId', filters.perfilId.toString());
      if (filters.imobiliariaId) params = params.set('imobiliariaId', filters.imobiliariaId.toString());
    }

    return this.http
      .get<any[]>(`${this.usuarioEndpoint}GetUsuarios`, { 
        headers: this.getHeader(this.loaderAtivo),
        params 
      })
      .pipe(map(lista => lista.map(raw => new UsuarioListResponse(raw))));
  }

  getUsuariosImobiliaria(imobiliariaId: number): Observable<UsuarioListResponse[]> {
    return this.http
      .get<any[]>(`${this.usuarioEndpoint}GetUsuariosImobiliaria/${imobiliariaId}`, { headers: this.getHeader(this.loaderAtivo) })
      .pipe(map(lista => lista.map(raw => new UsuarioListResponse(raw))));
  }

  temPermicaoFuncionalidade(usuarioId: number, funcinalidadeId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.usuarioEndpoint}TemPermicaoFuncionalidade/${usuarioId}/${funcinalidadeId}`,
      { headers: this.getHeader(this.loaderAtivo) }
    );
  }

  aceitarTermosUso(usuarioId: number): Observable<AceitarTermosResponse> {
    return this.http.post<AceitarTermosResponse>(
      `${this.usuarioEndpoint}AceitarTermosUso/${usuarioId}`,
      {},
      { headers: this.getHeader(this.loaderAtivo) }
    );
  }

  concluirOnboarding(usuarioId: number): Observable<ConcluirOnboardingResponse> {
    return this.http.post<ConcluirOnboardingResponse>(
      `${this.usuarioEndpoint}ConcluirOnboarding/${usuarioId}`,
      {},
      { headers: this.getHeader(this.loaderAtivo) }
    );
  }

  atualizarPerfil(request: AtualizarPerfilRequest): Observable<AtualizarPerfilResponse> {
    return this.http.put<AtualizarPerfilResponse>(
      `${this.usuarioEndpoint}AtualizarPerfil`,
      request,
      { headers: this.getHeader(this.loaderAtivo) }
    );
  }

  ativarDesativar(usuarioId: number, ativar: boolean): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.usuarioEndpoint}AtivarDesativar/${usuarioId}`,
      { ativar },
      { headers: this.getHeader(this.loaderAtivo) }
    );
  }

}
